/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminServiceUpdateGachaImageRequest } from '../../models/admin-service-update-gacha-image-request';
import { UpdateGachaImageResponse } from '../../models/update-gacha-image-response';

export interface AdminServiceUpdateGachaImage$Params {
  environment: 'UNDEFINED' | 'STAGING' | 'PRODUCTION';
  gachaId: string;
      body: AdminServiceUpdateGachaImageRequest
}

export function adminServiceUpdateGachaImage(http: HttpClient, rootUrl: string, params: AdminServiceUpdateGachaImage$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateGachaImageResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceUpdateGachaImage.PATH, 'put');
  if (params) {
    rb.path('environment', params.environment, {});
    rb.path('gachaId', params.gachaId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateGachaImageResponse>;
    })
  );
}

adminServiceUpdateGachaImage.PATH = '/api/v3/gateway/admin/{environment}/gacha/{gachaId}/image';
